import { GET_ALL_USERS } from '../actionTypes'
export default (state = {}, action) => {

	if (action.type === GET_ALL_USERS) {
		if (action.payload) {
			return action.payload;
		}
		return state;
	}
	return state;
}